// ── Opening recognition ─────────────────────────────────────────────────
// Matches the game's SAN move sequence against a small opening book so
// players learn opening names as they play. Longest match wins.

const OPENINGS = [
  { moves: 'e4', name: "King's Pawn Opening" },
  { moves: 'd4', name: "Queen's Pawn Opening" },
  { moves: 'c4', name: 'English Opening' },
  { moves: 'Nf3', name: 'Réti Opening' },
  { moves: 'e4 e5', name: 'Open Game' },
  { moves: 'e4 c5', name: 'Sicilian Defence' },
  { moves: 'e4 e6', name: 'French Defence' },
  { moves: 'e4 c6', name: 'Caro-Kann Defence' },
  { moves: 'e4 d6', name: 'Pirc Defence' },
  { moves: 'e4 d5', name: 'Scandinavian Defence' },
  { moves: 'e4 Nf6', name: 'Alekhine Defence' },
  { moves: 'd4 d5', name: 'Closed Game' },
  { moves: 'd4 Nf6', name: 'Indian Defence' },
  { moves: 'd4 f5', name: 'Dutch Defence' },
  { moves: 'e4 e5 Nf3', name: "King's Knight Opening" },
  { moves: 'e4 e5 Nf3 Nc6', name: 'Open Game — Knights' },
  { moves: 'e4 e5 Nf3 Nc6 Bb5', name: 'Ruy López (Spanish Opening)' },
  { moves: 'e4 e5 Nf3 Nc6 Bc4', name: 'Italian Game' },
  { moves: 'e4 e5 Nf3 Nc6 Bc4 Bc5', name: 'Italian Game — Giuoco Piano' },
  { moves: 'e4 e5 Nf3 Nc6 Bc4 Nf6', name: 'Italian Game — Two Knights' },
  { moves: 'e4 e5 Nf3 Nc6 d4', name: 'Scotch Game' },
  { moves: 'e4 e5 Nf3 Nf6', name: 'Petrov Defence' },
  { moves: 'e4 e5 Bc4', name: "Bishop's Opening" },
  { moves: 'e4 e5 f4', name: "King's Gambit" },
  { moves: 'e4 c5 Nf3', name: 'Sicilian — Open Variations' },
  { moves: 'e4 c5 Nf3 d6', name: 'Sicilian — Najdorf Setup' },
  { moves: 'e4 c5 Nf3 Nc6', name: 'Sicilian — Old Sicilian' },
  { moves: 'e4 c5 c3', name: 'Sicilian — Alapin' },
  { moves: 'e4 e6 d4 d5', name: 'French Defence — Main Line' },
  { moves: 'e4 c6 d4 d5', name: 'Caro-Kann — Main Line' },
  { moves: 'd4 d5 c4', name: "Queen's Gambit" },
  { moves: 'd4 d5 c4 dxc4', name: "Queen's Gambit Accepted" },
  { moves: 'd4 d5 c4 e6', name: "Queen's Gambit Declined" },
  { moves: 'd4 d5 c4 c6', name: 'Slav Defence' },
  { moves: 'd4 Nf6 c4 g6', name: "King's Indian Defence" },
  { moves: 'd4 Nf6 c4 e6', name: 'Indian Game — e6 Systems' },
  { moves: 'd4 Nf6 c4 e6 Nc3 Bb4', name: 'Nimzo-Indian Defence' },
  { moves: 'd4 Nf6 c4 g6 Nc3 d5', name: 'Grünfeld Defence' },
  { moves: 'd4 Nf6 Nf3 g6', name: "King's Indian Setup" },
  { moves: 'd4 d5 Nf3 Nf6 Bf4', name: 'London System' },
  { moves: 'd4 Nf6 Bf4', name: 'London System' },
  { moves: 'c4 e5', name: 'English — Reversed Sicilian' },
  { moves: 'c4 c5', name: 'English — Symmetrical' },
];

/**
 * @param {Array<{san:string}>|Array<string>} moveHistory
 * @returns {string|null} the deepest matching opening name
 */
export function detectOpening(moveHistory) {
  if (!moveHistory || moveHistory.length === 0) return null;
  const sans = moveHistory
    .slice(0, 10)
    .map(m => (typeof m === 'string' ? m : m.san))
    .filter(Boolean);
  const played = sans.join(' ');
  let best = null;
  for (const o of OPENINGS) {
    if (played === o.moves || played.startsWith(o.moves + ' ')) {
      if (!best || o.moves.length > best.moves.length) best = o;
    }
  }
  return best ? best.name : null;
}
